import axios from 'api';

// /api/super/notifications/ — the public-schema platform feed and this
// super-admin's own push devices. Distinct from /api/notifications/, which is
// tenant-scoped and invisible from the public schema.

export const getPlatformNotifications = (filtersData, signal) => {
  const { page_size, page, search, severity, category, event_kind, tenant_schema, is_read } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  if (severity) params.set('severity', severity);
  if (category) params.set('category', category);
  if (event_kind) params.set('event_kind', event_kind);
  if (tenant_schema) params.set('tenant_schema', tenant_schema);
  if (is_read != null) params.set('is_read', is_read);
  return axios.get(`/api/super/notifications/?${params.toString()}`, { signal });
};

export const getUnreadCount = (signal) => axios.get('/api/super/notifications/unread_count/', { signal });

export const markRead = (id) => axios.post(`/api/super/notifications/${id}/mark_read/`, {});

export const markAllRead = () => axios.post('/api/super/notifications/mark_all_read/', {});

// ----- device registry -----

export const listDevices = (signal) => axios.get('/api/super/notifications/devices/', { signal });

export const registerDevice = (payload) => axios.post('/api/super/notifications/devices/', payload);

export const deactivateDevice = (token) => axios.post('/api/super/notifications/devices/deactivate/', { token });

export const sendTestPush = () => axios.post('/api/super/notifications/devices/test_push/', {});
